import {
  getData,
  postData,
  patchData,
  deleteData
} from './Services'

export const getArtNoCombosPanel = async (searchTerm, searchRam, searchRub, searchSubr, 
searchMar, searchDes, page, perPage) => {
  let queryParams = [];

  if (searchTerm) {
    queryParams.push(`search=${encodeURIComponent(searchTerm)}`);
  }
  if (searchRam) {
    queryParams.push(`ramo_Id=${encodeURIComponent(searchRam)}`);
  }
  if (searchRub) {
    queryParams.push(`rubro_Id=${encodeURIComponent(searchRub)}`);
  }
  if (searchSubr) {
    queryParams.push(`subrubro_Id=${encodeURIComponent(searchSubr)}`);
  }
  if (searchMar) {
    queryParams.push(`marca_Id=${encodeURIComponent(searchMar)}`);
  }
  if (searchDes) {
    queryParams.push(`art_destacado=${encodeURIComponent(searchDes)}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/combos/articulos_no_combos", queryString);
}
;

export const postCombo = async (body) => {
  const res = await postData('/combos', body)
  return res
}

export const getComboById = async (id) => {
    const res = await getData(`/combos/${id}`)
    return res
}

export const patchCombo = async (id, body) => {
  const res = await patchData(`/combos/${id}`, body)
  return res
}

export const deleteCombo = async (id) => {
  const res = await deleteData(`/combos/${id}`)
  return res
}
